import { DestinationResponseModel, AllDestinationsResponseModel, CountryRequest } from '@gtpl/shared-models/masters';
import {  InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError,  errorHandler, ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { Any } from 'typeorm';
import { DestinationDTO } from './dto/destination.dto';
import { DestinationService } from './destination.service';
import {DestinationRequest} from './dto/destination.request'
import { CountryForDestinationRequest } from './dto/destination-for-country-request';
import { UserRequestDto } from './dto/user-request-dto';
@ApiTags('destination')
@Controller('destination')
export class DestinationController {
    constructor(private destinationService: DestinationService,
      private readonly applicationExceptionHandler: ApplicationExceptionHandler
      ) {}

    @Post('/createDestination')
    async createDestination(@Body() destinationDTO:DestinationDTO,isUpdate:boolean=false): Promise<DestinationResponseModel> {
    try {
        return await this.destinationService.createDestination(destinationDTO, false);
    } catch (error) {
        // return errorHandler(DestinationResponseModel,error);
        return this.applicationExceptionHandler.returnException(DestinationResponseModel, error);
    }
    }
  
  @Post('/updateDestination')
  async updateDestination(@Body() destinationDTO: DestinationDTO): Promise<DestinationResponseModel> {
    try {
      return await this.destinationService.createDestination(destinationDTO, true);
    } catch (error) {
      // return errorHandler(DestinationResponseModel, error);
      return this.applicationExceptionHandler.returnException(DestinationResponseModel, error);
    }
  }
  @Post('/getDestinationById')
  async getDestinationById(@Body() destinationRequest: DestinationRequest): Promise<DestinationResponseModel> {
    try {
      return await this.destinationService.getDestinationsById(destinationRequest);
    } catch (error) {
      // return errorHandler(DestinationResponseModel, error);
      return this.applicationExceptionHandler.returnException(DestinationResponseModel, error);
    }
  }
  @Post('/getAllDestinations')
  async getAllDestinations(@Body() req?:UserRequestDto): Promise<AllDestinationsResponseModel> {
    try {
      return await this.destinationService.getAllDestinations(req);
    } catch (error) {
      // return errorHandler(AllDestinationsResponseModel, error);
      return this.applicationExceptionHandler.returnException(AllDestinationsResponseModel, error);
    }
  }
  @Post('/getAllActiveDestinations')
  async getAllActiveDestinations(@Req() request: Request): Promise<AllDestinationsResponseModel> {
      try {
          return await this.destinationService.getAllActiveDestinations();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(AllDestinationsResponseModel, error)
      }
  }

@Post('/activateorDeactivateDestination')
async activateorDeactivateDestination(@Body() destinationreq: DestinationRequest): Promise<DestinationResponseModel> {
    try {

      return await this.destinationService.activateOrDeactivateCountry(destinationreq)
    } catch (err) {
        return this.applicationExceptionHandler.returnException(DestinationResponseModel, err);
    }
}

@Post('/getDestinationsByCountry')
async getDestinationsByCountry(@Body() countryReq: CountryForDestinationRequest): Promise<AllDestinationsResponseModel> {
    try {

      return await this.destinationService.getDestinationsByCountry(countryReq)
    } catch (err) {
        return this.applicationExceptionHandler.returnException(AllDestinationsResponseModel, err);
    }
}




}